export default __webpack_public_path__ + "static/media/img-id-photo@2x.c4202c93.png";